import {
  buildStatusCard,
  parseCardAction,
  StringDeduplicator,
  type TuituiCardCallbackMessage,
} from '@qihoo/tuitui-bot-sdk';
import { CHANNEL_ID } from '../const';
import { sendTextMsg, modifyInteractiveTuituiMsg } from '../outbound';
import type { ChatType } from '../chat_base';
import type { InboundAccount } from '../inbound';

const cardActionDedup = new StringDeduplicator(1000, 900);

export async function handleCardAction(params: {
  message: TuituiCardCallbackMessage;
  operatorAccount: string;
  chatId: string;
  chatType: ChatType;
  account: InboundAccount;
  log: any;
}): Promise<string | null> {
  const { message, operatorAccount, chatId, chatType, account, log } = params;
  const { accountId } = account;
  const result = parseCardAction({
    message,
    operatorAccount,
    chatId,
    deduplicationScope: accountId,
    deduplicator: cardActionDedup,
  });

  if (!result) return null;
  if ('error' in result) {
    log?.warn?.(`[${CHANNEL_ID}] AccountId: ${accountId}, rejected card action: ${result.error}, operator=${operatorAccount}`);
    try {
      await sendTextMsg(account, chatId, chatType, result.message, 'tuitui.card-action.invalid');
    } catch (err) {
      log?.warn?.(`[${CHANNEL_ID}] AccountId: ${accountId}, failed to send invalid card action notice: ${err}`);
    }
    return null;
  }

  if (message.msgid) {
    const operatorName = chatType === 'group'
      ? (message.user?.name || message.sender?.name || operatorAccount)
      : undefined;
    modifyInteractiveTuituiMsg(
      account,
      chatId,
      chatType,
      message.msgid,
      {
        msgtype: 'interactive',
        interactive: buildStatusCard({
          status: 'submitted',
          originalTitle: result.title,
          fieldsData: result.fields?.byLabel,
          operatorName,
        }),
      },
      'tuitui.card-update.patch',
    ).catch((err) => {
      log?.warn?.(`[${CHANNEL_ID}] AccountId: ${accountId}, failed to patch card status: ${err}`);
    });
  }

  log?.info?.(`[${CHANNEL_ID}] AccountId: ${accountId}, card action command: ${result.command}`);
  return result.command;
}
